'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CouponsConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponsConstants = exports.CouponsConstants = (0, _keymirror2.default)({
    LOAD_COUPONS: null,
    LOAD_COUPONS_SUCCESS: null,
    LOAD_COUPONS_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/coupons.js
// module id = 1868
// module chunks = 0